import { ssrPrepareErrorsClient } from '@confluence/ssr-utilities/entry-points/SSRPrepareErrorsClient.ts';
import { SSRMeasures } from '@confluence/action-measures/entry-points/SSRMeasures.ts';
import { StatsigConfigurations } from '@confluence/statsig-client/entry-points/StatsigConfigurations.ts';

export const SLOW_QUERY_DEFAULT_TIMEOUT =
	process.env.CLOUD_ENV === 'staging' ||
	process.env.CLOUD_ENV === 'branch' ||
	process.env.CLOUD_ENV === 'dev'
		? 1000
		: 500;

export const slowQueryGuard = async (
	name: string,
	task: () => Promise<any>,
	timeout: number,
	skipSignal?: Promise<void>,
): Promise<boolean> => {
	let timer: ReturnType<typeof setTimeout> | null = null;

	const slowQueryGuardTimeout = StatsigConfigurations.getNumber(
		'confluence_frontend_slow_query_guard_timeout',
		SLOW_QUERY_DEFAULT_TIMEOUT,
	);

	const finalTimeout = Math.max(timeout, slowQueryGuardTimeout);
	const timeoutPromise = new Promise<boolean>((resolve) => {
		timer = setTimeout(() => {
			// eslint-disable-next-line no-console
			ssrPrepareErrorsClient.submitError(
				new Error(`SlowQueryGuard "${name}" timed out after ${finalTimeout}ms`),
			);
			resolve(false);
		}, finalTimeout);
	});

	const runTask = async () => {
		await SSRMeasures.run(`ssr-app/prepare/preloadQuery/slowQueryGuard:${name}`, task);
		if (timer) {
			clearTimeout(timer);
		}
		return true;
	};

	return Promise.race(
		skipSignal
			? [timeoutPromise, skipSignal.then(() => true), runTask()]
			: [timeoutPromise, runTask()],
	);
};
